<div #interactiveBar (mouseover)="mouseover(current, breakdown, tab)" (mouseleave)="mouseleave(current, breakdown, tab)">
    <!-- Current Status -->
    <div class="cv-interactive-bar" [ngClass]="{'hide': forceStatusBreakdownView}" #current>
        <div class="cv-interactive-bar-segment" [ngStyle]="{'background-color': data.color ? data.color : '#e5e5e5'}">
        </div>
    </div>
    <!-- Status Breakdown -->
    <div class="cv-interactive-bar" [ngClass]="{'hide': !forceStatusBreakdownView}" #breakdown>
        <!-- Segments -->
        <div class="cv-interactive-bar-segment"
            [ngStyle]="{'background-color': segment.color, 'width': segment.percent + '%'}"
            *ngFor="let segment of data.segments">
        </div>

        <!-- Tooltips -->
        <div class="cv-interactive-bar-tooltips">
            <div class="cv-interactive-bar-tooltip" [ngStyle]="{'background-color': segment.tooltip?.background}"
                *ngFor="let segment of data.segments">
                <span *ngIf="segment.tooltip">
                    {{segment.tooltip.displayValue}}
                </span>
            </div>
            <div *ngFor="let segment of data.segments">
                <div class="cv-interactive-bar-tooltip-tail"
                    [ngStyle]="{'border-color': segment.tooltip.background + ' transparent'}" *ngIf="segment.tooltip">
                </div>
            </div>
        </div>

        <!-- Bar Tab -->
        <svg class="cv-interactive-bar-tab" #tab>
            <path class="fill-whaleTail" d="M 0,0 H 12 V 4 L 6,10 0,4 Z"></path>
        </svg>
    </div>
</div>
